import type {Facility} from "../pages/settings/facilities/useFacility";

/**
 * L'établissement depuis lequel l'écran se lit (jumeau front de
 * `App\Support\ViewpointFacility`).
 *
 * - Super admin : l'établissement consulté via le sélecteur, sinon le sien.
 * - Tous les autres : l'établissement du compte. Un admin de groupe basculé sur
 *   un enfant reste « vu depuis le groupe » (colonnes d'établissement, etc.),
 *   comme avant le sélecteur super admin.
 *
 * Fonction pure, sans import du contexte : ContextProvider s'en sert aussi.
 */
export function resolveViewpointFacility(
    user: { is_super_admin?: boolean | number; facility?: Facility | null },
    currentFacility: Facility | null,
): Facility | null {
    if (user.is_super_admin && currentFacility) {
        return currentFacility;
    }

    return user.facility ?? null;
}
